import { orchestrator } from 'satcheljs';
import { manageSecurity } from '../actions/manageSecurity';
import { logUsage } from 'owa-analytics';

let manageSecurityUrl = 'https://go.microsoft.com/fwlink/?linkid=872493';

export default orchestrator(manageSecurity, async function manageSecurity() {
    logUsage('PremiumDashSecurityManageClicked');
    window.open(manageSecurityUrl, '_blank');
});
